import { styled } from '@mui/material';
import Button from '@mui/material/Button';

const AddButton = styled(Button)(({ theme }) => ({
	color: '#fff',
	display: 'block',
	margin: '1em auto',

	[theme.breakpoints.up('md')]: {
		marginRight: '3.5em',
	},
}));

export default AddButton;
